module.exports = __webpack_public_path__ + "img/GTM-integration-vidjet-step1.189ba19a.png";